import React from 'react';
import { IconProps } from './model/IconInterface';

const ScaleIcon: React.FC<IconProps> = ({ size = 20, color = 'currentColor' }) => (
    <svg
        width={size}
        height={size}
        viewBox='0 0 24 24'
        fill='none'
        stroke={color}
        strokeWidth={1.8}
        strokeLinecap='round'
        strokeLinejoin='round'
        aria-hidden
    >
        <path d='M12 3v18' />
        <path d='M5 6h14' />
        <path d='M5 6l-3 7a4 4 0 0 0 8 0z' />
        <path d='M19 6l3 7a4 4 0 0 1-8 0z' />
        <path d='M8 21h8' />
    </svg>
);

export default ScaleIcon;
